import React, { useEffect } from "react";
import PageComponent from "../../../component/common/Page-Component";
import CONSTANTS from "../../../util/constant/CONSTANTS";
import useHttp from "../../../hooks/use-http";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const Blog = () => {
  return (
    <>
      <PageComponent
        trackEventName="Blog"
        tableHeaders="BLOG"
        tableTitle="Blog List"
        getAPI={CONSTANTS.API.getBlog}
        getData={(res) => {
          return res?.map((data, idx) => {
            return {
              ...data,
              no: `B${data?.id.toString().padStart(7, "0")}`,
              date: moment(data?.createdAt).format("lll"),
            };
          });
        }}
        extraResData="rows"
        formData
        modalButton="Add New Blog"
        addModalTitle="Add New Blog"
        editModalTitle="Edit Blog"
        modalFields="BLOG_MODAL"
        editModalFields="EDIT_BLOG_MODAL"
        datefilter
        addAPI={CONSTANTS.API.addBlog}
        editAPI={CONSTANTS.API.editBlog}
        editformData
        deleteData
        deleteAPI={CONSTANTS.API.deleteBlog}
        searchfilter
        isSearch={true}
        searchAPI="/admin/blog?search="
        dateTime
        extraFilter
        extraFilterField={CONSTANTS.FILTER.BLOG}
        extraFilterParam=""
        modalWidth={1100}
      />
    </>
  );
};

export default Blog;
